module.exports = __webpack_public_path__ + "static/media/united_card_3.7d782a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/united_card_3.jpg
// module id = 524
// module chunks = 0